<input
  [id]="id"
  autocomplete="off"
  maxlength="60"
  class="select-option form-control"
  [(ngModel)]="itemDescricao"
  (ngModelChange)="onChangeItemDescricao()"
  [ngClass]="{'focus':isShowItems, 'no-cursor': readOnly}"
  [readOnly]="readOnly"
  placeholder="Digite ou selecione o item"
  type="text"
  (click)="hideItems()"
  [required]="required"
  #input="ngModel">
  <span class="chevron fa fa-chevron-down"
    *ngIf="!readOnly"
    aria-hidden="true"
    (click)="showHideItems()">
  </span>

<div class="text-danger" *ngIf="input?.errors?.required && input?.touched">{{ requiredMessage }}</div>
<ul
  class="lista-items"
  *ngIf="isShowItems">

  <li
    class="item-custom"
    *ngFor="let item of itemsSelecionar">
    <a (click)="selectItem(item)">{{ label(item) }}</a>
  </li>

  <li
    class="item-custom"
    *ngIf="itemsSelecionar.length === 0 && addModalForm" style="white-space: wrap;">
    <a>Parece que não existe vendedor cadastrado com esse nome, realize o cadastro abaixo.</a>
  </li>

  <li
  class="item-custom"
  *ngIf="addModalForm"
  >
    <a (click)="openAddModal()" style="display: flex;">
      <span class="icon add"></span>
      <span class="addButton">
        Adicionar vendedor
      </span>
    </a>
  </li>

  <li
  class="item-custom"
  *ngIf="!getItemPorLabel() && itemDescricao && itemDescricao.length > 3 && !addModalForm">
    <a (click)="onClickAdd(itemDescricao)">+ Incluir {{ itemDescricao }}</a>
  </li>

</ul>
